/**
 * Mobile Copilot chatbot panel — full-height bottom drawer.
 */
import React, { useCallback } from 'react';
import { Box, Drawer } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import { useAISearchPanel } from '@hooks/useAISearchPanel';
import { CopilotChatbotPanel } from '@components/chatbot/copilot/CopilotChatbotPanel';

export interface ChatbotMobileBottomPanelProps {
  open: boolean;
}

export const ChatbotMobileBottomPanel: React.FC<ChatbotMobileBottomPanelProps> = ({ open }) => {
  // const theme = useTheme();
  const { hidePanel } = useAISearchPanel();

  const handleClose = useCallback(() => {
    const activeElement = document.activeElement as HTMLElement;
    activeElement?.blur?.();
    hidePanel();
  }, [hidePanel]);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      keepMounted
      disableAutoFocus
      disableRestoreFocus
      disableEnforceFocus
      PaperProps={{
        sx: {
          height: 'calc(100dvh - 56px)',
          maxHeight: 'calc(100dvh - 56px)',
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          pt: 1,
          pb: 0.5,
          position: 'relative',
        }}
      >
        {/* <Box
          sx={{
            width: 36,
            height: 4,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.text.secondary, 0.3),
          }}
        />
        <IconButton
          onClick={handleClose}
          aria-label="Close Search"
          size="small"
          sx={{
            position: 'absolute',
            right: 8,
            top: 4,
            color: '#64748B',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton> */}
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <CopilotChatbotPanel />
      </Box>
    </Drawer>
  );
};

export default ChatbotMobileBottomPanel;
